<!-- Flat card: every part is a direct grid child of .ws-product-card (layout in styles/themable/_product-card.scss). -->
<div class="ws-product-card ws-product-card--request ws-product-card--overlay-always"
     [ngClass]="cardClasses()"
     (click)="onCardClick($event)">
  <ng-container *ngTemplateOutlet="blocks().media"></ng-container>
  <ng-container *ngTemplateOutlet="blocks().badges"></ng-container>

  <!-- touch: a tap anywhere on the media opens the form -->
  <div class="ws-product-card__tap-area ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-touch"></div>

  <button class="btn ws-button ws-button--primary ws-product-card__buy ws-product-card__buy--overlay ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-touch"
          [translate]="'orderProcess.cakesOverview.cakeItem.buy'"
          (click)="$event.stopPropagation(); open.emit()">
    Buy
  </button>

  <!-- desktop -->
  <div class="ws-product-card__overlay-panel ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-desktop"></div>

  <a class="ws-product-card__overlay-link ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-desktop"
     [routerLink]="builderLink()?.link"
     [queryParams]="builderLink()?.queryParams"></a>

  <div class="text-center px-3 mb-3 ws-product-card__overlay-title ws-product-card__overlay-title--tight ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-desktop">{{ cake().name }}</div>

  <a class="btn ws-button ws-button--primary btn-long ws-product-card__order-now ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-desktop"
     [routerLink]="builderLink()?.link"
     [queryParams]="builderLink()?.queryParams"
     [translate]="'common.orderNow'">
    Order now
  </a>

  <ng-container *ngTemplateOutlet="blocks().footer"></ng-container>
</div>
